import { Injectable } from '@angular/core';
import { CONFIGURATION } from '../configuration/configuration';

import * as CryptoJS from 'crypto-js';
//declare var CryptoJS;

@Injectable()
export class EncryptionService {
	constructor() {
	}

	public encrypt(pObject: string): string {
		try {
			let key = this.generateKey();
			let vCipher = CryptoJS.AES.encrypt(pObject, key);
			return key + vCipher;
		} catch (pErr) {
			throw pErr;
		}
	}

	public decrypt(pCipher: string): string {
		try {
			let key = pCipher.substring(0,CONFIGURATION.ENCRYPTION.KEY_LENGTH);
			let vResult = CryptoJS.AES.decrypt(pCipher.substring(CONFIGURATION.ENCRYPTION.KEY_LENGTH), key);
			return vResult.toString(CryptoJS.enc.Utf8);
		} catch (pErr) {
			throw pErr;
		}
	}

	private generateKey() {

		let key = '';
		let possible = CONFIGURATION.ENCRYPTION.KEY;
		for (let i = 0; i < CONFIGURATION.ENCRYPTION.KEY_LENGTH; i++) {
			key += possible.charAt(Math.floor(Math.random() * possible.length));
		}

		return key.toString();

	}

	/**
	 * input must string
	 * output will be string
	 */
	encryptStorage(pObject: string): string {
		try {
			let key = this.generateKey();
			let vCipher = CryptoJS.AES.encrypt(pObject, key);
			vCipher = vCipher + key;
			return vCipher;
		} catch (pErr) {
			// console.log('error enryptStorage: ' + pErr);
			throw pErr;
		}
	}

	decryptStorage(pCipher: string): string {
		try {
			let key = pCipher.substring(pCipher.length - CONFIGURATION.ENCRYPTION.KEY_LENGTH);
			let vResult = CryptoJS.AES.decrypt(pCipher.substring(0, pCipher.length - CONFIGURATION.ENCRYPTION.KEY_LENGTH), key);
			return vResult.toString(CryptoJS.enc.Utf8);
		} catch (pErr) {
			// console.log('error decryptStorage: ' + pErr);
			throw pErr;
		}
	}

	public decodeToken(token: string): any {
		let parts = token.split('.');

		if (parts.length !== 3) {
		throw new Error('JWT must have 3 parts');
		}

		let decoded = this.urlBase64Decode(parts[1]);
		if (!decoded) {
		throw new Error('Cannot decode the token');
		}

		return JSON.parse(decoded);
	}

	 public urlBase64Decode(str: string): string {
		let output = str.replace(/-/g, '+').replace(/_/g, '/');
		switch (output.length % 4) {
		case 0: { break; }
		case 2: { output += '=='; break; }
		case 3: { output += '='; break; }
		default: {
			throw 'Illegal base64url string!';
		}
		}
		return this.b64DecodeUnicode(output);
	}

	private b64DecodeUnicode(str: any) {
		return decodeURIComponent(Array.prototype.map.call(this.b64decode(str), (c: any) => {
		return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
		}).join(''));
	}

	private b64decode(str: string): string {
		let chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
		let output: string = '';

		str = String(str).replace(/=+$/, '');

		if (str.length % 4 == 1) {
		throw new Error("'atob' failed: The string to be decoded is not correctly encoded.");
		}

		for (
		// initialize result and counters
		let bc: number = 0, bs: any, buffer: any, idx: number = 0;
		// get next character
		buffer = str.charAt(idx++);
		// character found in table? initialize bit storage and add its ascii value;
		~buffer && (bs = bc % 4 ? bs * 64 + buffer : buffer,
			// and if not first of each 4 characters,
			// convert the first 8 bits to one ascii character
			bc++ % 4) ? output += String.fromCharCode(255 & bs >> (-2 * bc & 6)) : 0
		) {
		// try to find character in table (0-63, not found => -1)
		buffer = chars.indexOf(buffer);
		}
		return output;
	}

}


// WEBPACK FOOTER //
// /home/maheshreddy/PRP_FE/src/app/shared/services/encryption.service.ts